import React from 'react'
import loader from '../Images/LiznrLogo.svg'
import './loader.css'
const Loader = () => {
  return (
    <div className='flex flex-col justify-center items-center loader'><img src={loader} alt="" style={{width:"150px",height:"150px" }} />
    <p className="loading-text">Loading<span className="dots"></span></p>
    </div>
  )
}

export default Loader